export const topicsOnMap = (proposals) => {
  const seen = new Map();
  proposals.forEach((p) => {
    const t = p.topic_items?.[0];
    if (t && !seen.has(t.id)) seen.set(t.id, t);
  });
  return [...seen.values()];
};

export const TopicLegend = ({ proposals, topic, onTopic, variant = "overlay", testId = "map-legend" }) => {
  const topics = topicsOnMap(proposals);
  if (!topics.length) return null;
  return (
    <div className={variant === "overlay" ? "map-legend" : "legend-row"} role="group" aria-label="Topics on the map" data-testid={testId}>
      {topics.map((t) => (
        <button key={t.id} type="button" className="legend-chip" aria-pressed={topic === t.id} onClick={() => onTopic(topic === t.id ? "" : t.id)} data-testid={`${testId}-${t.id}`}>
          <span aria-hidden="true" style={{ width: 10, height: 10, borderRadius: "50%", background: t.color, flex: "none" }} />{t.name}
        </button>
      ))}
    </div>
  );
};
